<template>
    <div>
        <input type="hidden" :id="id" readonly="readonly">
    </div>
</template>
<script>
import $$ from 'jquery'
import 'ion-rangeslider/js/ion.rangeSlider.js'
import 'ion-rangeslider/css/ion.rangeSlider.css'
import 'ion-rangeslider/css/ion.rangeSlider.skinModern.css'
import 'ion-rangeslider/img/sprite-skin-modern.png'

export default {
    props: {
        id: {
            type: String,
            default: function () {
                return Math.random().toString(16).replace('.', '')
            }
        },
        max: {
            type: Number,
            default: 100
        },
        min: {
            type: Number,
            default: 0
        },
        step: {
            type: Number,
            default: 0
        },
        range: {
            type: Array,
            default: function () {
                return [0, 100]
            }
        },
        name: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'single'
        }
    },
    'data': function () {
        return {
            from: 0,
            to: 0
        }
    },
    created: function () {
        let that = this
        that.from = that.range[0]
        if (that.type === 'double') {
            that.to = that.range[1]
        }
    },
    mounted: function () {
        let that = this
        let options = {
            'type': that.type,
            'grid': true,
            'min': that.min,
            'max': that.max,
            'from': that.from,
            'step': that.step,
        }
        if (that.type === 'double') {
            options.to = that.to
        }
        $$(`#${that.id}`).ionRangeSlider(options)
        $$(`#${that.id}`).on('change', function () {
            let val = $$(`#${that.id}`).val().split(';')
            that.$emit('change', that.id,val.map(v => (Number(v))))
        })
    },
    destroyed: function () {
        let that = this
        $$(`#${that.id}`).off('change')
    }
}
</script>
<style lang="less">

</style>



// WEBPACK FOOTER //
// range-slider.vue?4367c302